import {CoreActionTypes} from './types';
import {AppStore} from "../../desktop";

export const actionLogChanged = () => {
	AppStore.dispatch({type: CoreActionTypes.LOG_CHANGED})
}


